import doctor1 from "../../images/doctor1.png";
import doctor2 from "../../images/doctor2.png";
import doctor3 from "../../images/doctor3.png";
import volunteer1 from "../../images/volenteer1.png";
import volunteer2 from "../../images/volenteer2.png";
import volunteer3 from "../../images/volenteer3.png";
import travel1 from "../../images/travel1.png";
import travel2 from "../../images/travel2.png";
import travel3 from "../../images/travel3.png";
import apartment1 from "../../images/apartment1.png";
import apartment2 from "../../images/apartment2.png";
import apartment3 from "../../images/apartment3.png";
import athena1 from "../../images/athena1.png";
import athena2 from "../../images/athena2.png";
import athena3 from "../../images/athena3.png";
import modern1 from "../../images/modern1.png";
import modern2 from "../../images/modern2.png";
import modern3 from "../../images/modern3.png";
import store1 from "../../images/store1.png";
import store2 from "../../images/store2.png";
import store3 from "../../images/store3.png";

const projectInfo = [
  {
    id: 101,
    title: "Store Management app at Aristocracy System",
    description:
      "It’s a midlevel store management software for any store management company need. Build by two junior MERN stack developers. This software backend full functionality build and some frontend develop by me. It’s a very enjoyable project for my life. You can see it. Admin login => Email: abuhorain2016@gmail.com Pass: abuhorain2016",
    technology: [
      "JavaScript",
      "React.js",
      "Node.js",
      "Express.js",
      "MongoDB",
      "Heroku",
      "Netlify",
      "BootStrap",
      "Material-UI",
      "HTML & CSS",
    ],
    img_1: store1,
    img_2: store2,
    img_3: store3,
    liveSite: "https://management-application.netlify.app/",
  },

  {
    id: 102,
    title: "Modern E-commerce app at Aristocracy System",
    description:
      "This is a fully dynamic Modern E-commerce website, Build by two junior MERN stack developers. It’s very large software for junior developers. You can see it if you want, you can control the whole site from its Dashboard. User security has not been done yet, so can control this site. But finally, It’s not ready for the client or market, need some modify & update.",
    technology: [
      "JavaScript",
      "React.js",
      "Node.js",
      "Express.js",
      "MongoDB",
      "Heroku",
      "Netlify",
      "BootStrap",
      "Material-UI",
      "HTML & CSS",
    ],
    img_1: modern1,
    img_2: modern2,
    img_3: modern3,
    liveSite: "https://modern-e-commerce.netlify.app/",
  },

  {
    id: 1,
    title: "Doctor's Portal",
    description:
      "A Single page Application with dashboard where people can choice the date and time and fix an appointment. Any one doctor can review his appointments and prescribe medicine to a Patient from dashboard. Finally this is Online base Doctors & patient projects.",
    technology: [
      "React.js",
      "Node.js",
      "Express.js",
      "JavaScript",
      "Firebase",
      "Heroku",
      "BootStrap.5",
      "Material-UI",
      "HTML & CSS",
    ],
    img_1: doctor1,
    img_2: doctor2,
    img_3: doctor3,
    liveSite: "https://my-doctors-protal.firebaseapp.com/",
    clientGithub: "https://github.com/abuhorainhero/doctors-portal-client",
    serverGithub: "https://github.com/abuhorainhero/doctor-portal-server",
  },
  {
    id: 2,
    title: "Volunteer Network",
    description:
      "A single page Application with dashboard where are any volunteer can pick the date and fix an voluntary service registration. Volunteer group admin, who any can cancel a volunteer.",
    technology: [
      "React.js",
      "Node.js",
      "Express.js",
      "Firebase",
      "Heroku",
      "JavaScript",
      "BootStrap.5",
      "HTML & CSS",
    ],
    img_1: volunteer1,
    img_2: volunteer2,
    img_3: volunteer3,
    liveSite: "https://volunteer-assig.firebaseapp.com/",
    clientGithub: "https://github.com/abuhorainhero/volunteer-client",
    serverGithub: "https://github.com/abuhorainhero/volunteer-server",
  },
  {
    id: 3,
    title: "Travel Guru",
    description:
      "This is a single pase traveling man base Project. This system is awesome, very helpful for travel man. Any traveling man can booking using this app where he will be traveling. He can see how many hotels there are in that place through in this application.",
    technology: [
      "React.js",
      "JavaScript",
      "Firebase",
      "BootStrap",
      "google map",
      "HTML & CSS",
    ],
    img_1: travel1,
    img_2: travel2,
    img_3: travel3,
    liveSite: "https://my-travel-guru-react-app.firebaseapp.com/",
    clientGithub: "https://github.com/abuhorainhero/my-travel-guru-react",
  },
  {
    id: 4,
    title: "Apartment Hurt",
    description:
      "It's my first group project. The purpose of this project is that if someone wants to grow the House. Then he will say ‘Admin’. Then, Admin will add to the Website with all their information of his House. * Again, If a person wants to grow the House. Then this “Apartment Hunt” can take the house booking at the Website. * If a person needs more than one House. He can book more then one House.",
    img_1: apartment1,
    img_2: apartment2,
    img_3: apartment3,
    technology: [
      "React.js",
      "JavaScript",
      "Firebase",
      "BootStrap",
      "Heroku",
      "Netlify",
      "HTML & CSS",
    ],
    liveSite: "https://aparment-hunt.netlify.app/",
    clientGithub: "https://github.com/abuhorainhero/apartment-hunt-client",
    serverGithub: "https://github.com/mamunur13525/appoinment-hunt-server",
  },
  {
    id: 5,
    title: "Athena Design",
    description: "It's group project & Simple design project",
    img_1: athena1,
    img_2: athena2,
    img_3: athena3,
    technology: ["React.js", "BootStrap", "HTML", "CSS"],
    liveSite: "https://athenadesign.netlify.app/",
    clientGithub: "https://github.com/mamunur13525/Athena-Design",
  },
];

export default projectInfo;
